/* Myco Pet quick size picker.
   The theme's "+" / quick-add buttons on product cards open Quick View, which expects the theme's
   standard product page. The rebranded product pages are custom, so Quick View crashed and nothing
   happened. This replaces that: tap "+" -> pick size -> add to cart -> the theme's cart drawer opens. */
(function () {
  if (window.__mycoQuickAdd) return;
  window.__mycoQuickAdd = true;

  var lang = (document.documentElement.lang || 'en').slice(0, 2);
  var T = {
    en: { title: 'Choose your size', close: 'Close', added: 'Added to cart', error: 'Sorry, that could not be added. Please try again.', view: 'See full details' },
    fr: { title: 'Choisissez votre format', close: 'Fermer', added: 'Ajouté au panier', error: 'Désolé, impossible d’ajouter ce produit. Veuillez réessayer.', view: 'Voir tous les détails' },
    es: { title: 'Elige tu tamaño', close: 'Cerrar', added: 'Añadido al carrito', error: 'Lo sentimos, no se pudo añadir. Inténtalo de nuevo.', view: 'Ver todos los detalles' }
  }[lang] || null;
  if (!T) T = { title: 'Choose your size', close: 'Close', added: 'Added to cart', error: 'Sorry, that could not be added. Please try again.', view: 'See full details' };
  var vs = window.variantStrings || {};
  var ADD = vs.addToCart || 'Add to cart';
  var SOLD = vs.soldOut || 'Sold out';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';
  var fmt;
  var loc = lang + (currency === 'CAD' ? '-CA' : currency === 'USD' ? '-US' : '');
  try { fmt = new Intl.NumberFormat(loc, { style: 'currency', currency: currency }); } catch (e) { fmt = null; }
  function money(cents) { var v = cents / 100; return fmt ? fmt.format(v) : '$' + v.toFixed(2); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function cleanName(n) { return String(n).replace(/\s*\((size|taille|tamaño)\)\s*/i, ' ').trim(); }

  var css = '' +
    '.mqa{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:flex-end;justify-content:center;background:rgba(7,26,51,.55);font-family:"Instrument Sans",system-ui,sans-serif;color:#071A33}' +
    '.mqa *{box-sizing:border-box}' +
    '.mqa__sheet{width:100%;max-width:480px;max-height:88vh;overflow:auto;background:#fff;border-radius:28px 28px 0 0;padding:20px 20px calc(20px + env(safe-area-inset-bottom));box-shadow:0 -20px 60px -20px rgba(7,26,51,.45);animation:mqa-up .22s ease-out}' +
    '@media (min-width:750px){.mqa{align-items:center}.mqa__sheet{border-radius:28px;padding:24px}}' +
    '@keyframes mqa-up{from{transform:translateY(24px);opacity:.4}to{transform:none;opacity:1}}' +
    '@media (prefers-reduced-motion:reduce){.mqa__sheet{animation:none}}' +
    '.mqa__top{display:flex;gap:14px;align-items:center;margin-bottom:16px}' +
    '.mqa__img{flex-shrink:0;width:72px;height:72px;border-radius:16px;background:#F6F9FD;object-fit:contain}' +
    '.mqa__name{font-size:18px;font-weight:700;line-height:1.25;margin:0}' +
    '.mqa__price{font-size:16px;font-weight:600;color:#005099;margin-top:4px}' +
    '.mqa__x{margin-left:auto;align-self:flex-start;flex-shrink:0;width:44px;height:44px;border:0;border-radius:50%;background:#EAF4FF;color:#071A33;font-size:22px;line-height:1;cursor:pointer}' +
    '.mqa__h{font-size:13px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:#3B4658;margin:14px 0 8px}' +
    '.mqa__opts{display:flex;flex-direction:column;gap:8px}' +
    '.mqa__opt{display:flex;align-items:center;justify-content:space-between;gap:10px;width:100%;min-height:52px;padding:10px 16px;border:2px solid #CFE0F2;border-radius:16px;background:#fff;color:#071A33;font:600 16px/1.3 "Instrument Sans",system-ui,sans-serif;text-align:left;cursor:pointer}' +
    '.mqa__opt[aria-pressed="true"]{border-color:#007FFF;background:#EAF4FF}' +
    '.mqa__opt[disabled]{opacity:.45;cursor:not-allowed;text-decoration:line-through}' +
    '.mqa__opt small{font-weight:600;color:#3B4658;font-size:14px;white-space:nowrap}' +
    '.mqa__foot{position:sticky;bottom:calc(-20px - env(safe-area-inset-bottom));margin:0 -20px calc(-20px - env(safe-area-inset-bottom));padding:12px 20px calc(16px + env(safe-area-inset-bottom));background:#fff;box-shadow:0 -12px 20px -16px rgba(7,26,51,.35)}' +
    '@media (min-width:750px){.mqa__foot{bottom:-24px;margin:0 -24px -24px;padding:12px 24px 20px}}' +
    '.mqa__add{display:flex;align-items:center;justify-content:center;width:100%;min-height:56px;margin-top:0;border:0;border-radius:999px;background:#007FFF;color:#fff;font:700 17px "Instrument Sans",system-ui,sans-serif;cursor:pointer}' +
    '.mqa__add[disabled]{background:#9CB7D6;cursor:not-allowed}' +
    '.mqa__msg{margin:0 0 6px;font-size:14px;color:#B3261E;min-height:1em}' +
    '.mqa__more{display:block;text-align:center;margin:14px 0 8px;font-size:15px;font-weight:600;color:#005099}' +
    '.mqa button:focus-visible,.mqa a:focus-visible{outline:3px solid #007FFF;outline-offset:2px}';
  var style = document.createElement('style'); style.textContent = css; document.head.appendChild(style);

  var cache = {};
  function getProduct(handle) {
    if (!cache[handle]) cache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('product ' + r.status); return r.json(); });
    return cache[handle];
  }

  var open = null;
  function close() {
    if (!open) return;
    open.el.remove(); document.documentElement.style.overflow = open.prevOverflow;
    document.removeEventListener('keydown', open.onKey, true);
    if (open.opener && open.opener.focus) open.opener.focus();
    open = null;
  }

  function show(product, opener) {
    close();
    try { var dr = document.querySelector('cart-drawer'); if (dr && dr.init) dr.init(); } catch (e) {}
    var options = product.options || [];
    var single = product.variants.length === 1;
    // start on the first available variant
    var start = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    var sel = (start.options || []).slice();

    var el = document.createElement('div');
    el.className = 'mqa';
    el.innerHTML =
      '<div class="mqa__sheet" role="dialog" aria-modal="true" aria-labelledby="mqa-name">' +
      '<div class="mqa__top">' +
      (product.featured_image ? '<img class="mqa__img" alt="" src="' + esc(product.featured_image) + (product.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160">' : '') +
      '<div><p class="mqa__name" id="mqa-name"></p><div class="mqa__price" data-price></div></div>' +
      '<button type="button" class="mqa__x" aria-label="' + esc(T.close) + '">×</button></div>' +
      '<div data-groups></div>' +
      '<a class="mqa__more" href="' + esc(product.url) + '">' + esc(T.view) + '</a>' +
      '<div class="mqa__foot"><p class="mqa__msg" role="status" data-msg></p>' +
      '<button type="button" class="mqa__add" data-add></button></div></div>';
    el.querySelector('#mqa-name').textContent = product.title.split(/\s+[-–—|]\s+/)[0];

    var groups = el.querySelector('[data-groups]');
    if (!single) {
      options.forEach(function (opt, i) {
        var h = document.createElement('p'); h.className = 'mqa__h';
        h.textContent = options.length > 1 ? cleanName(opt.name) : T.title;
        var wrap = document.createElement('div'); wrap.className = 'mqa__opts'; wrap.setAttribute('role', 'group'); wrap.setAttribute('aria-label', cleanName(opt.name));
        opt.values.forEach(function (val) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'mqa__opt';
          b.dataset.i = i; b.dataset.v = val;
          b.innerHTML = '<span></span><small></small>';
          b.firstChild.textContent = val;
          b.addEventListener('click', function () { sel[i] = val; render(); });
          wrap.appendChild(b);
        });
        groups.appendChild(h); groups.appendChild(wrap);
      });
    }

    function current() {
      return product.variants.filter(function (v) { return (v.options || []).every(function (o, i) { return o === sel[i]; }); })[0];
    }
    var addBtn = el.querySelector('[data-add]'), priceEl = el.querySelector('[data-price]'), msg = el.querySelector('[data-msg]');
    function render() {
      var v = current();
      el.querySelectorAll('.mqa__opt').forEach(function (b) {
        var i = +b.dataset.i, val = b.dataset.v;
        b.setAttribute('aria-pressed', sel[i] === val ? 'true' : 'false');
        // price + availability if this value were chosen with the other current choices
        var trial = sel.slice(); trial[i] = val;
        var tv = product.variants.filter(function (x) { return (x.options || []).every(function (o, k) { return o === trial[k]; }); })[0];
        b.querySelector('small').textContent = tv ? (tv.available ? (options.length === 1 ? money(tv.price) : '') : SOLD) : '';
        b.disabled = !tv || !tv.available;
      });
      priceEl.textContent = v ? money(v.price) : '';
      var ok = v && v.available;
      addBtn.disabled = !ok;
      addBtn.textContent = ok ? ADD + ' · ' + money(v.price) : SOLD;
      msg.textContent = '';
    }
    render();

    addBtn.addEventListener('click', function () {
      var v = current(); if (!v || !v.available) return;
      addBtn.disabled = true; msg.textContent = '';
      var drawer = document.querySelector('cart-drawer');
      try { if (drawer && drawer.init) drawer.init(); } catch (e) {}
      var fd = new FormData();
      fd.append('id', v.id); fd.append('quantity', 1);
      var sections = [];
      try { if (drawer && drawer.getSectionsToRender) sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}
      if (sections.length) { fd.append('sections', sections.join(',')); fd.append('sections_url', window.location.pathname); }
      var url = (window.routes && window.routes.cart_add_url) || (root + 'cart/add');
      fetch(url, { method: 'POST', body: fd, headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { msg.textContent = res.description || res.message || T.error; addBtn.disabled = false; return; }
          addBtn.textContent = '✓ ' + T.added;
          try { if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartAdd, { source: 'myco-quick-add', productVariantId: v.id, cartData: res }); } catch (e) {}
          setTimeout(function () {
            close();
            if (drawer && drawer.renderContents && res.sections) { try { drawer.renderContents(res); return; } catch (e) {} }
            if ((window.theme && theme.settings && theme.settings.cartDrawer && theme.settings.cartDrawer.atcAction === 'page') || !drawer) { window.location = (window.routes && window.routes.cart_url) || (root + 'cart'); return; }
            try { drawer.reload ? drawer.reload() : drawer.open && drawer.open(); } catch (e) {}
          }, 450);
        })
        .catch(function () { msg.textContent = T.error; addBtn.disabled = false; });
    });

    el.addEventListener('click', function (e) { if (e.target === el) close(); });
    el.querySelector('.mqa__x').addEventListener('click', close);
    var onKey = function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key === 'Tab') { // keep focus inside the sheet
        var f = [].slice.call(el.querySelectorAll('button:not([disabled]),a[href]'));
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    };
    document.addEventListener('keydown', onKey, true);
    open = { el: el, opener: opener, onKey: onKey, prevOverflow: document.documentElement.style.overflow };
    document.documentElement.style.overflow = 'hidden';
    document.body.appendChild(el);
    var first = el.querySelector('.mqa__opt[aria-pressed="true"]:not([disabled])') || addBtn;
    first.focus({ preventScroll: true });
  }

  // Take over the theme's quick-add triggers on product cards (capture phase runs before the theme's handlers).
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.card__hover-button, modal-opener .quick-add__submit, product-form .quick-add__submit');
    if (!t) return;
    var card = t.closest('[data-product-handle]') || (t.closest('product-card') && t.closest('product-card').querySelector('[data-product-handle]'));
    var handle = card && card.getAttribute('data-product-handle');
    if (!handle) return; // not a card we understand: leave the theme alone
    e.preventDefault(); e.stopImmediatePropagation();
    if (t.getAttribute('aria-busy') === 'true') return;
    t.setAttribute('aria-busy', 'true');
    getProduct(handle).then(function (p) { show(p, t); })
      .catch(function () { var a = card.closest('product-card') && card.closest('product-card').querySelector('a[href*="/products/"]'); window.location = a ? a.href : root + 'products/' + handle; })
      .finally(function () { t.removeAttribute('aria-busy'); });
  }, true);
})();

/* Cart drawer: the theme's renderContents() clears "is-empty" only on the inner panel, so after an add from
   Ask Mikvah or the size picker the drawer itself stayed marked empty and hid the new item. Clear it first. */
(function () {
  function patch() {
    var C = window.customElements && customElements.get('cart-drawer');
    if (!C || C.prototype.__mycoEmptyFix) return;
    var orig = C.prototype.renderContents;
    if (typeof orig !== 'function') return;
    C.prototype.renderContents = function () { this.classList.remove('is-empty'); return orig.apply(this, arguments); };
    C.prototype.__mycoEmptyFix = true;
  }
  if (!window.customElements) return;
  if (customElements.get('cart-drawer')) patch(); else customElements.whenDefined('cart-drawer').then(patch);
})();
